import {AppStateService} from "../services/appStateService";

export class PriceStore {

    private readonly appStateService = new AppStateService();

    get()
    {
        return this.appStateService.getPrices();
    }

    set(prices)
    {
        this.appStateService.setPrices(prices);
    }
}
